/**
 * talent-category-overrides.ts — 员工分类覆盖映射表
 * key: talent id (number 或 string), value: 新分类名（用户端完整分类名）
 * 此文件由管理员永久固化，优先级高于 roleCategories 自动推断
 */
export const talentCategoryOverrides: Record<number | string, string> = {
  // ── 数字员工（de 系列，string id）──
  'de3': '媒体运营类',   // 雅婷：数据运营类 → 媒体运营类

  // ── 普通员工（number id）──
  54:  '数据运营类',     // 任沐凡：技术开发类 → 数据运营类
  70:  '技术开发类',     // 姚舒曼：其他专业岗 → 技术开发类
  75:  '技术开发类',     // 秦沐阳：其他专业岗 → 技术开发类
  92:  '生产管理岗',     // 刘梦菲：其他专业岗 → 生产管理岗
  93:  '生产管理岗',     // 曹君岳：其他专业岗 → 生产管理岗
  94:  '生产管理岗',     // 张语彤：其他专业岗 → 生产管理岗
  95:  '生产管理岗',     // 段沐辰：其他专业岗 → 生产管理岗
  108: '产品设计类',     // 温君峰：创意设计类 → 产品设计类
  109: '产品设计类',     // 吕承恒：创意设计类 → 产品设计类
  110: '产品设计类',     // 梁欣琪：创意设计类 → 产品设计类
  128: '产品设计类',     // 董明琪：创意设计类 → 产品设计类
  130: '项目管理运营类', // 李思彤：创意设计类 → 项目管理运营类
  183: '媒体运营类',     // 杜清禾：数据运营类 → 媒体运营类
  204: '项目管理运营类', // 黄令夏：媒体运营类 → 项目管理运营类
  206: '技术开发类',     // 张清予：项目管理运营类 → 技术开发类
  216: '项目管理运营类', // 蔡令仪：其他专业岗 → 项目管理运营类
  217: '媒体运营类',     // 孙寻珩：项目管理运营类 → 媒体运营类
  223: '媒体运营类',     // 苏望舒：销售市场类 → 媒体运营类
  224: '媒体运营类',     // 廖临安：销售市场类 → 媒体运营类
  225: '媒体运营类',     // 崔寻川：销售市场类 → 媒体运营类
  226: '媒体运营类',     // 黄初禾：销售市场类 → 媒体运营类
  227: '媒体运营类',     // 范屿珩：销售市场类 → 媒体运营类
  228: '媒体运营类',     // 姚清越：销售市场类 → 媒体运营类
  232: '项目管理运营类', // 杨予安：其他专业岗 → 项目管理运营类
  247: '媒体运营类',     // 陈清禾：项目管理运营类 → 媒体运营类
  250: '其他专业岗',     // 段亦川：销售市场类 → 其他专业岗
  252: '其他专业岗',     // 戴临安：销售市场类 → 其他专业岗
  273: '媒体运营类',     // 范令禾：项目管理运营类 → 媒体运营类
  299: '法务合规类',     // 任沐凡：其他专业岗 → 法务合规类
  301: '技术开发类',     // 孙嘉岳：其他专业岗 → 技术开发类
  302: '技术开发类',     // 秦清苒：其他专业岗 → 技术开发类
  303: '技术开发类',     // 刘令安：其他专业岗 → 技术开发类
};